export default __webpack_public_path__ + "media/images/landing-42-550x420-c978a802c11cfa33e92e1626f65b4b1f.jpg";